import {useState} from 'react';
import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import _ from 'lodash';
import {Accordion, Avatar, AvatarList} from 'shared/components';

const EventPill = observer(({event}) => {
  const {subjectEmployee} = event;
  const avatarModifier = subjectEmployee ? 'WhatsGoingOn-pill--withAvatar' : '';

  return (
    <div className={`WhatsGoingOn-pill WhatsGoingOn-pill--${event.pillStyle} ${avatarModifier}`}>
      {subjectEmployee ?
        <span className='WhatsGoingOn-pillAvatar'>
          <Avatar employee={subjectEmployee} size='xs'/>
        </span> :
        <span className='WhatsGoingOn-dot'/>}
      <span className='WhatsGoingOn-pillTitle'>{event.title}</span>
    </div>
  );
});

const EventRow = observer(({event}) => {
  return (
    <div className='WhatsGoingOn-row'>
      <EventPill event={event}/>
      <div className='WhatsGoingOn-time'>
        {event.allDay ?
          <FormattedMessage id='hr_dashboard.whats_going_on.All day'/> :
          event.timeLabel}
      </div>
    </div>
  );
});

const EventGroupRow = observer(({group}) => {
  const [expanded, setExpanded] = useState(false);
  const hasAvatars = !_.isEmpty(group.employees);
  const avatarModifier = hasAvatars ? 'WhatsGoingOn-pill--withAvatar' : '';

  return (
    <div className='WhatsGoingOn-group'>
      <div
        className='WhatsGoingOn-row clickable user-select-none'
        onClick={() => setExpanded(!expanded)}
      >
        <div className={`WhatsGoingOn-pill WhatsGoingOn-pill--${group.pillStyle} ${avatarModifier}`}>
          {hasAvatars ?
            <span className='WhatsGoingOn-pillAvatars'>
              <AvatarList employees={group.employees} limit={group.avatarLimit} size='xs'
                moreIndicator='ellipsis'/>
            </span> :
            <span className='WhatsGoingOn-dot'/>}
          <span className='WhatsGoingOn-pillTitle'>
            <FormattedMessage id={group.titleId} values={{count: group.count}}/>
          </span>
          <i className={`material-symbols-solid WhatsGoingOn-groupChevron ${expanded ? 'expanded' : ''}`}>
            {'chevron_right'}
          </i>
        </div>
      </div>
      <Accordion active={expanded}>
        <div className='WhatsGoingOn-groupEvents'>
          {group.events.map(event => <EventRow key={event.key} event={event}/>)}
        </div>
      </Accordion>
    </div>
  );
});

const Row = observer(({row}) => {
  return row.rowType === 'group' ?
    <EventGroupRow group={row}/> :
    <EventRow event={row}/>;
});

const EventList = observer(({agenda}) => {
  return (
    <div className='WhatsGoingOn-events'>
      {agenda.rows.map(row => <Row key={row.key} row={row}/>)}
    </div>
  );
});

export default EventList;
